import Client from '../hooks/useAxios';

export const DELGuest = async (id) => {
    const response = await Client().delete('/guest/'+ id);
    return response.data;
  };